export default __webpack_public_path__ + "static/media/smedetoften-property-03.c7a7e77b.jpg";